// src/config.js

// ✅ SSR-safe: only read window.* if it exists
const host =
  typeof window !== 'undefined' && window.location
    ? window.location.hostname
    : '';

// ✅ Consider common local dev hosts (localhost, 127.x, ::1, LAN IPs)
const isLocal =
  host === 'localhost' ||
  host === '127.0.0.1' ||
  host === '::1' ||
  /^192\.168\./.test(host) ||
  /^10\./.test(host) ||
  /^172\.(1[6-9]|2\d|3[0-1])\./.test(host);

// ✅ Allow .env to override (CRA: REACT_APP_*, Vite: VITE_*)
// ✅ Normalize trailing slash so `${BASE_URL}/path` never becomes `//path`
export const BASE_URL = (
  process.env.REACT_APP_API_BASE || // CRA
  process.env.VITE_API_BASE_URL || // Vite
  (isLocal
    ? 'http://localhost:5000'
    : 'https://virtual-scouting-network.onrender.com')
).replace(/\/$/, '');

// ✅ Frontend base (Golden Rule: use window.location.origin)
export const FRONTEND_ORIGIN =
  typeof window !== 'undefined' && window.location
    ? window.location.origin
    : '';

// If your login page is on the same frontend, this is safest.
// Still allow env overrides if needed.
export const LOGIN_URL =
  process.env.REACT_APP_LOGIN_URL ||
  process.env.VITE_LOGIN_URL ||
  (FRONTEND_ORIGIN ? `${FRONTEND_ORIGIN}/login` : '/login');

// (Optional) Convenient endpoints
export const ENDPOINTS = {
  countries: `${BASE_URL}/api/countries`,
};

